import type { FeatureGroup } from '../../../../types';
import { DOMAINS_FEATURE_GROUP } from '../group';

export const DOMAINS_EMAIL_FEATURE_GROUP: FeatureGroup = {
  guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e2ff00',
  name: 'domains:email',
  description: 'Email domain features — register, verify, and manage email domains',
  product: 'account',
  parentGuid: DOMAINS_FEATURE_GROUP.guid,
};
